






































import { Component, Vue } from "vue-property-decorator";
import { getChanges } from "@/domain/changeLog";

@Component
export default class Test extends Vue {
  color = "primary";

  get changes() {
    return getChanges(this.lang);
  }

  get lang() {
    return this.$store.state.lang.data;
  }
}
